import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import classNames from '../../node_modules/classnames/index.js';
import styles from './OverlayScrim.module.scss.js';

var _excluded = ["className"];
/**
 * @private
 */
var OverlayScrim = function OverlayScrim(props) {
  var className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.scrim, className)
  }, rest));
};

export { OverlayScrim };
